var _rect, _path, _path2, _g, _rect2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceholderService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    fill: "#1E2A24"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 116H44C51 116 51 94 58 94H86C93 94 93 70 100 70H160",
    stroke: "#32C46B",
    strokeOpacity: 0.16,
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 48H34C40 48 40 66 46 66H80C86 66 86 44 92 44H160",
    stroke: "#F4D03F",
    strokeOpacity: 0.12,
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.18
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 116,
    r: 3,
    fill: "#32C46B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 70,
    r: 3,
    fill: "#32C46B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 66,
    r: 2.5,
    fill: "#F4D03F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 44,
    r: 2.5,
    fill: "#F4D03F"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 49,
    width: 76,
    height: 58,
    rx: 14,
    fill: "#26352E",
    stroke: "#AEECC6",
    strokeOpacity: 0.42,
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M61 49C63 39 70 34 80 34C90 34 97 39 99 49",
    stroke: "#AEECC6",
    strokeOpacity: 0.42,
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67 75H93",
    stroke: "#AEECC6",
    strokeOpacity: 0.58,
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80 78V101",
    stroke: "#AEECC6",
    strokeOpacity: 0.58,
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M72 101H88",
    stroke: "#AEECC6",
    strokeOpacity: 0.58,
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M58 124H102",
    stroke: "#AEECC6",
    strokeOpacity: 0.22,
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderService);
export default __webpack_public_path__ + "static/media/placeholder-service.486fc9d13a547827bbb127e60324ada0.svg";
export { ForwardRef as ReactComponent };